import {cs} from "./chain-services";
import {UseState} from "./use-state";
import {createElement as h} from "react";
import {parseUrlQuery} from "../utils/parse-url-query";
import {UseEffect} from "./use-effect";

export const QueryString = ({param, next}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => {
            const query = parseUrlQuery(window.location.search);
            return query && query[param];
        },
        next,
    })],
    ({state}, next) => h(UseEffect, {
        fn: () => {
            setTimeout(() => {
                const query = parseUrlQuery(window.location.search);

                const v = query && query[param];
                if (state.value !== v) {
                    state.onChange(v);
                }
            }, 0);
        },
        next,
    }),
    ({state}) => next({
        value: state.value,
        onChange: (v) => {
            state.onChange(v, () => {
                history.replaceState(null,"", window.location.pathname + "?"+param+"=" + (v == null ? "" : encodeURIComponent(v)));
            });
        },
    }),
);